import PageLayout from "../../components/layout/page";
import BusinessQuotationReport from "../businessProposal/report";

export default function BusinessReport() {
    return (
        <PageLayout className="dashboard-inner-page"
            View={
                <>
                    <BusinessQuotationReport />
                </>
            }
        />
    );
}
